import ModulePlanningBookingSlotResourceModel from '../../generated/types/model/resource/ModulePlanningBookingSlotResourceModel';

export default class ModulePlanningBookingSlotResourceViewModel extends ModulePlanningBookingSlotResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
